import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExtendedLinkOff = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M38.0986 32.5586L35.1299 29.4909C36.4493 29.128 37.5214 28.4271 38.346 27.388C39.1707 26.349 39.583 25.1367 39.583 23.7513C39.583 22.102 39.0058 20.7001 37.8512 19.5456C36.6967 18.3911 35.2948 17.8138 33.6455 17.8138H25.7288V13.8555H33.6455C36.3834 13.8555 38.7171 14.8203 40.6468 16.75C42.5765 18.6797 43.5413 21.0135 43.5413 23.7513C43.5413 25.6315 43.0548 27.3633 42.0817 28.9466C41.1086 30.53 39.7809 31.7339 38.0986 32.5586ZM31.3695 25.7305L27.4111 21.7721H31.6663V25.7305H31.3695ZM39.1872 44.7305L2.77051 8.3138L5.54134 5.54297L41.958 41.9596L39.1872 44.7305ZM21.7705 33.6471H13.8538C11.116 33.6471 8.78223 32.6823 6.85254 30.7526C4.92285 28.8229 3.95801 26.4892 3.95801 23.7513C3.95801 21.4753 4.65072 19.4466 6.03613 17.6654C7.42155 15.8841 9.2028 14.7131 11.3799 14.1523L15.0413 17.8138H13.8538C12.2045 17.8138 10.8026 18.3911 9.64811 19.5456C8.4936 20.7001 7.91634 22.102 7.91634 23.7513C7.91634 25.4006 8.4936 26.8025 9.64811 27.957C10.8026 29.1115 12.2045 29.6888 13.8538 29.6888H21.7705V33.6471ZM15.833 25.7305V21.7721H19.0492L22.958 25.7305H15.833Z",
		fill: "url(#paint0_linear_31303_114353)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_31303_114353",
		x1: 2.55598,
		y1: 45.2461,
		x2: 49.49,
		y2: 13.5064,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", { stopColor: "#142F95" }),
			/* @__PURE__ */ _jsx("stop", {
				offset: .5,
				stopColor: "#2563EB"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#CACBFF"
			})
		]
	}) })]
});
export default SvgExtendedLinkOff;
